const config = {
  basename: "",
  defaultPath: "/",
  fontFamily: `'Poppins', sans-serif`,
  borderRadius: 12,
  rowsPerPage: [1, 5, 10, 15, 50, 100],
  token_key: "2b09b1330556a63a99de23eb6d9dcd8922c443db",
};

export default config;
